<template>
    <div>

        <div class="adaptation-block">
            <div class="adaptation-block__column">
                <uzhnet-back-button @click="$router.push('/main')" />
                <div class="bot-chat-container">
                    <div class="header-block">
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M119 1H114L125 11H130L119 1Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M114 1H0" stroke="#CACACA"/>
                            </svg>
                        </div>
                        <div class="label">
                            <img src="@/assets/icons/specials/bot-avatar-ai.svg" alt="">
                        </div>
                        <div class="barrier">
                            <svg width="100%" height="200%" viewBox="0 0 132 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13 11H18L7 1H2L13 11Z" fill="#CACACA" stroke="#CACACA"/>
                                <path d="M18 11H132" stroke="#CACACA"/>
                            </svg>
                        </div>
                    </div>

                    <div class="chat-wrapper">
                        <div class="chat" ref="scrollContainer">
                            <div v-for="mess in messages" :class="[mess.type == 'bot' ? 'message-bot' : 'message-user']">
                                <div :class="[mess.type == 'bot' ? 'message-bot__avatar' : 'message-user__avatar']">
                                    <img v-if="mess.type == 'bot'" src="@/assets/icons/specials/bot-mini-avatar.svg" alt="">
                                    <img v-if="mess.type == 'user'" src="@/assets/icons/specials/user-mini-avatar.svg" alt="">
                                </div>
                                <div :class="[mess.type == 'bot' ? 'message-bot__text-wrapper' : 'message-user__text-wrapper']">

                                    <div v-html="formattedText(mess.text)" :class="[mess.type == 'bot' ? 'message-bot__text' : 'message-user__text']"></div>
                                </div>
                            </div>
                            <div v-if="botWrittingFlag" class="message-bot">
                                <div class="message-bot__avatar">
                                    <img src="@/assets/icons/specials/bot-mini-avatar.svg" alt="">
                                </div>
                                <div class="message-bot__text-wrapper">

                                    <div class="message-bot__text" style="font-style: italic; opacity: 0.7;">
                                        Друкує{{ dotsState }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="send-message-form">
                        <div class="send-message-form__logo">
                            <img src="@/assets/icons/specials/bot-mini-avatar-2.svg" alt="">
                        </div>
                        <div class="send-message-form__bot-input">
                            <div class="bot-input-wrapper">
                                <input v-model="newMessageText" ref="messageInput" type="text" class="bot-input-wrapper__input" placeholder="Питай, що хочеш...">
                            </div>
                        </div>
                        <div @click="sendMessage" class="send-message-form__send-icon">
                            <img src="@/assets/icons/specials/send-icon.svg" alt="">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import { ref, onMounted } from 'vue'

import { useMainStore } from '@/store/mainStore'
import ApiManager from '@/services/ApiManager'
import { calculateFingerprint } from '@/services/fingerprint'
import { decryptMessage } from '@/services/cryptoUtils';
import { getAccountByLogin } from '@/db/accountService';

import { requestMasterVisit } from '@/services/BotChatHistory';

export default {
    name: "BotHelperView",

    setup() {
        const store = useMainStore();

        const scrollContainer = ref(null)

        const newMessageText = ref('')
        const messageInput = ref(null)

        const messages = ref([
        ]);

        const threadId = ref(null);
        const assistantId = ref(null);

        const botWrittingFlag = ref(false)

        const dots = ref(['.', '..', '...']);
        const dotsState = ref('.');

        const scrollToBottom = () => {
            const container = scrollContainer.value;
            if (container) {
                container.scrollTop = container.scrollHeight;
            }
        };

        const masterRequestFlag = ref(false);

        const sendMessage = async () => {
            if (!newMessageText.value) {
                return;
            }

            if (masterRequestFlag.value) {
                await requestMasterVisit(store.login, '', newMessageText.value);
                messages.value.push({
                    type: 'user',
                    text: newMessageText.value
                });
                messages.value.push({
                    type: 'bot',
                    text: 'Заявка на виклик майстра відправлена'
                });
                newMessageText.value = '';
                masterRequestFlag.value = false;
                return;
            }

            botWrittingFlag.value = true;

            const currentMessage = newMessageText.value;

            newMessageText.value = '';

            messages.value.push({
                type: 'user',
                text: currentMessage
            });

            const bot_response = (await ApiManager.sendMessageBot(currentMessage, threadId.value, assistantId.value, store.user_id)).data;

            if (bot_response.response == 'Формую заявку на виклик майстра. Будь ласка уточніть діючий номер телефону') {
                masterRequestFlag.value = true;
            }

            messages.value.push({
                type: 'bot',
                text: bot_response.response
            });

            scrollToBottom();

            botWrittingFlag.value = false;

            messageInput.value.focus();
        };

        const startBot = async () => {
            const login = store.login;

            botWrittingFlag.value = true;

            const currentUserResponse = await getAccountByLogin(store.login);
            const currentUserData = currentUserResponse._data;
            const fingerprint = await calculateFingerprint();

            const decryptedToken = await decryptMessage(currentUserData.token, fingerprint, currentUserData.iv);
            //reverse btoa
            const token = atob(decryptedToken);

            const password = token.split(':')[1];

            if (!login || !password) {
                alert("Please enter both login and password.");
                return;
            }

            const locale = localStorage.getItem('locale') || 'ua';

            const bot_response = (await ApiManager.botAuth(login, password, locale)).data;

            threadId.value = bot_response.thread_id;
            assistantId.value = bot_response.assistant_id;

            botWrittingFlag.value = false;

            messages.value.push({
                    type: 'bot',
                    text: bot_response.message
            });

            scrollToBottom();
        }

        const formattedText = (startText) => {
            let formatted = startText;

            // Регулярний вираз для жирного тексту **текст**
            const boldRegex = /\*\*([^\*]+)\*\*/g;
                formatted = formatted.replace(
                boldRegex,
                (match, boldText) => `<strong>${boldText}</strong>`
            );

            // Регулярний вираз для посилань [текст](посилання)
            const linkRegex = /\[([^\]]+)\]\((https?:\/\/[^\)]+)\)/g;
                formatted = formatted.replace(
                linkRegex,
                (match, text, url) => `<a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a>`
            );

            // Обробка посилань текст (посилання)
            const inlineLinkRegex = /([^\s]+)\s\((https?:\/\/[^\)]+)\)/g;
            formatted = formatted.replace(
                inlineLinkRegex,
                (match, text, url) =>
                `${text} <a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            );

            return formatted;
        }

        const getSessionReport = async () => {
            const report = await ApiManager.checkUserSessionBot(store.login, threadId.value, assistantId.value);

            messages.value.push({
                type: 'bot',
                text: report.data
            });
        }

        onMounted(async () => {
            scrollToBottom();

            await startBot();
            await getSessionReport();

            setInterval(() => {
                dotsState.value = dots.value[dots.value.indexOf(dotsState.value) + 1] || dots.value[0];
            }, 500);
        });

        return {
            scrollContainer,
            messages,
            newMessageText,
            sendMessage,
            messageInput,
            formattedText,
            botWrittingFlag,
            dotsState
        };
    }
}
</script>
<style lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Codystar:wght@300;400&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');

    .bot-chat-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .chat-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: end;
        height: 70vh;
        width: 100%;
    }

    .chat {
        height: max-content;
        width: 100%;

        overflow-y: auto;

        scroll-behavior: smooth;

        position: relative;
        z-index: 99991;

        .message-bot {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 10px 0;

            &__avatar {
                width: 28px;
                height: 28px;
                overflow: hidden;
                margin-right: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

            }

            &__text {
                padding: 10px;
                font-size: 14px;
                font-family: 'Montserrat', sans-serif;
                color: #fff;
                white-space: pre-wrap;
            }

            &__text a {
                color: #E0C522;
            }

            &__text-wrapper {
                background-color: rgba(#C7C8D1, 0.05);
                width: 80%;
            }

        }

        .message-user {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            padding: 10px 0;

            &__avatar {
                width: 28px;
                height: 28px;
                overflow: hidden;
                margin-right: 10px;

                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

            }

            &__text {
                padding: 10px;
                font-size: 14px;
                font-family: 'Montserrat', sans-serif;
                color: #E0C522;
                white-space: pre-wrap;
            }

            &__text a {
                color: #E0C522;
            }

            &__text-wrapper {
                background-color: rgba(#E0C522, 0.05);
                width: 80%;
            }

        }

    }

    .send-message-form {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        width: 90%;
        padding: 10px 0;
        border-top: 1px solid #E0C522;
        z-index: 9999;

        &__logo {
            width: 38px;
            height: 28px;
            overflow: hidden;
            margin-right: 10px;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

        }

        &__bot-input {
            position: relative;
            z-index: 9999;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: start;
            padding: 10px;
            font-size: 14px;
            background-color: rgba(#C7C8D1, 0.05);

            top: 2px;

            color: #fff;

            .bot-input-wrapper {
                width: 100%;
            }

            input {
                width: 100%;
                padding: 5px;
                font-size: 14px;
                background-color: transparent;
                border: none;
                color: #fff;
                outline: none;
                font-family: 'Montserrat', sans-serif;
            }

        }

        &__send-icon {
            width: 38px;
            height: 28px;
            overflow: hidden;
            margin-left: 10px;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }

        }

    }
</style>
